export default __webpack_public_path__ + "static/media/mocktext-img.70fee4aa.png";